import React, { useEffect, useState } from "react";
import "./report.scss";
import { Button, Col, Divider, Drawer, Row, Table, Typography } from "antd";
import Icon from "../../../components/icon/icon";
import Filters from "../../../components/drawer/drawer";
import { HandleErrors } from "../../../utils/handleErrors";
import { getReportService } from "../../../services/event.service";
import { GetReportFilterReq } from "../../../interfaces/event.interface";
import Moment from "jalali-moment";
import { NewReportModal } from "../../../components/newReportModal/newReportModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { GetPermissionRes } from "../../../interfaces/role.interface";
import { PermissionCode } from "../../../enum/permission";
import Export from "../export/export";
import { useParams, useSearchParams } from "react-router-dom";

const Report = () => {
  const health = useSelector<RootState, string>(
    (root) => root.app.health
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const [open, setOpen] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState<any[]>([]);

  const [refreshExportData, setRefreshExportData] = useState(false);

  const [filters, setFilters] = useState({
    start_date: Moment().add(-1, "day").format("YYYY-MM-DD"),
    end_date: Moment().format("YYYY-MM-DD"),
    event_type: ""
  } as GetReportFilterReq);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(()=>{
    let f = {} as any
    searchParams.forEach((data, key) =>{
      if(data){
        switch (key) {
          case 'support_64_bit':
            f[key] = data == 'true' ? true : false
            break;
          case 'support_32_bit':
            f[key] = data == 'true' ? true : false
            break;
          case 'event_risk':
            f[key] = parseInt(data)
            break;
          case 'event_risk_gt':
            f[key] = parseInt(data)
            break;
          case 'event_risk_lt':
            f[key] = parseInt(data)
            break;
          default:
            f[key] = data
            break;
        }
      }
    });  

    if(!f['start_date']){
      f['start_date'] = Moment().add(-1, "day").format("YYYY-MM-DD")
    }

    if(!f['end_date']){
      f['end_date'] =  Moment().format("YYYY-MM-DD")
    }

    if(!f['event_type']){
      f['event_type'] = ""
    }

    setFilters(f)
    getData(f);
  },[health])

  const getData = async (f: GetReportFilterReq) => {
    try {
      if(health == 'license-false'){
        return;
      }
      setLoading(true);
      const res = await getReportService(f);
      setData(res.list);
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };


  const columns = [
    {
      title: "تاریخ",
      dataIndex: "date",
      key: "date",
      render: (date: string)=>{
        return(<div>
          <Typography.Text>{Moment(date).format('jYYYY-jMM-jDD HH:mm:ss')}</Typography.Text>
        </div>)
      }
    },
    {
      title: "آدرس IP",
      dataIndex: "request_ip",
      key: "request_ip",
    },
    {
      title: "نوع رخداد",
      dataIndex: "event_type",
      key: "event_type",
    },
    {
      title: "ورژن اندروید",
      dataIndex: "android_version",
      key: "android_version",
    },
    {
      title: "ورژن اپلیکیشن",
      dataIndex: "app_version",
      key: "app_version",
    },
    {
      title: "مدل دستگاه",
      dataIndex: "device_model",
      key: "device_model",
      render : (item: any, row: any)=>{
        return(<div>
          <Typography.Text>{row.device_manufacturer} {row.device_model}</Typography.Text>
        </div>)
      }
    },
    {
      title: "نام پکیج",
      dataIndex: "package_name",
      key: "package_name",
    },

    {
      title: "",
      dataIndex: "download",
      key: "download",
      render: (item: any, record: any) => (
        <>
          {record.download && (
            <Button href={record.donwload} className="download">
              <Icon src="/assets/icons/Down Line.svg" />
              <Typography.Text>دانلود</Typography.Text>
            </Button>
          )}
        </>
      ),
    },
  ];

  return (
    <div className="Report">
      {health == 'license-false' && <div style={{
          position: 'absolute',
          zIndex: '100000',
          width: '100%',
          height: '100%',
          top: 0,
          right: 0,
          backdropFilter: 'blur(3px)',
          backgroundColor: 'rgba(255, 255, 255, 0.5)' /* optional tint */
        }}>
      </div>}

      <Row justify="space-between" align="middle">
        <Col>
          <Typography.Text className="title"> گزارش‌ها</Typography.Text>
        </Col>
        <Col className="btn-box">
          {userPermissions.find(p => p.code === PermissionCode.createExport) && <Button className="download-btn" onClick={()=>{setDownloadModal(true)}}>
            دانلود گزارش‌
          </Button>}
          {userPermissions.find(p => p.code === PermissionCode.getDistinctValueOfFiled) && <Button className="filter-btn" onClick={showDrawer}>
            <Icon src="/assets/icons/Add - Circle.svg" />
            <Typography.Text className="itle">فیلتر</Typography.Text>
          </Button>}
        </Col>
      </Row>

      <Row className="table-container">
        <Col xs={24} style={{minWidth: '900px'}}>
          <Table
            dataSource={data}
            columns={columns}
            rowKey={(e) => (e.id)}
            loading={loading}
            expandable={{
              expandedRowRender: (record) => (
                <p style={{ margin: 10 }}>{
                  <div className="report-table-expandable-container">
                    <Row justify={'start'}>
                      <Col xs={8} className={"data-box"}>
                        <Typography.Text className="title">شناسه دستگاه: </Typography.Text>
                        <Typography.Text className="value">{record.device_id}</Typography.Text>
                      </Col>
                      {/* <Col xs={8} className={"data-box"}>
                        <Typography.Text className="title">نام اکتیویتی: </Typography.Text>
                        <Typography.Text className="value">{record.activity_name}</Typography.Text>
                      </Col> */}
                      <Col xs={8} className={"data-box"}>
                        <Typography.Text className="title">میزان ریسک: </Typography.Text>
                        <Typography.Text className="value">{record.event_risk}</Typography.Text>
                      </Col>
                      {/* <Col xs={8} className={"data-box"}>
                        <Typography.Text className="title">نام استان: </Typography.Text>
                        <Typography.Text className="value">{record.geo_province_fa}</Typography.Text>
                      </Col> */}
                      <Col xs={8} className={"data-box"}>
                        <Typography.Text className="title">نام کشور: </Typography.Text>
                        <Typography.Text className="value">{record.request_ip_country_name}</Typography.Text>
                      </Col>  
                    </Row>
                  </div>
                }</p>
              ),
              rowExpandable: (record) => true,
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
            <Divider />
        </Col>
      </Row>

      {userPermissions.find(p => p.code === PermissionCode.getAllExports) && <Export refresh={refreshExportData} />}

      <NewReportModal
        show={downloadModal}
        onClose={()=>{
          setDownloadModal(false)
          if(refreshExportData){
            setRefreshExportData(false)
          }else{
            setRefreshExportData(true)
          }
        }}
        filters={filters}
      />
      <Drawer
        title="فیلتر"
        size="large"
        onClose={onClose}
        open={open}
        closeIcon={<Icon src="/assets/icons/Close.svg" />}
      >
        <Filters value={filters} onChange={(e)=>{
          setFilters(e)
          getData(e)
          setOpen(false)
        }} />
      </Drawer>
    </div>
  );
};

export default Report;
